import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    InputAdornment,
    TextField
} from "@mui/material"
import React from "react"
import StatusComponent from "./StatusComponent";
import {useTranslation} from "i18nano";
import {preventDefaultOnDropFiles} from "../helpers/stubFunctions";
import {CommonProps} from "./types/types";
import {Choice} from "../api/types/Choice";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {withSharedMemo} from "./memo/memoComponent";
import DisplayTextComponent from "./DisplayTextComponent";

interface CheckboxesComponentProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: React.FocusEventHandler<any>
    choices: Choice[],
    other: boolean,
}

const CheckboxesComponent = ({
                                 value,
                                 onChange,
                                 errorText = "",
                                 onFocus,
                                 status = StatusUpdateAnswer.NONE,
                                 required, editable, choices, other, displayText, id,
                                 hint
                             }: CheckboxesComponentProps) => {
    const t = useTranslation();

    let values = value.split(",");
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let oldValues: string[];
        if (values.length === 0) {
            oldValues = [];
        } else {
            oldValues = Array.from(new Set(value.split(",")));
        }
        if (e.target.checked) {
            if (e.target.value === "Other") {
                oldValues.push("o:");
            } else {
                oldValues.push(e.target.value);
            }
        } else {
            if (e.target.value === "Other") {
                oldValues = oldValues.filter(v => !v.startsWith("o:"));
            } else {
                oldValues = oldValues.filter(v => v !== e.target.value);
            }
        }
        onChange({
            target: {
                value: oldValues.join(",")
            }
        } as React.ChangeEvent<HTMLInputElement>);
    }

    const handleOtherChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!values.find(a => a.startsWith("o:"))) {
            values.push(`o:${e.target.value}`);
        } else {
            values = values.map(v => v.startsWith("o:") ? `o:${e.target.value}` : v);
        }
        onChange({
            target: {
                formNoValidate: true,
                value: values.join(",")
            }
        } as React.ChangeEvent<HTMLInputElement>);
    }


    return (
        <FormControl disabled={!editable} required={required} error={errorText !== ""}>
            <div style={{display: "flex"}}>
                <FormLabel required={false} id="demo-radio-buttons-group-labelqwe">
                    <DisplayTextComponent text={displayText} required={required} hint={hint}/>
                </FormLabel>
                <StatusComponent status={status}/>
            </div>
            <FormGroup
                aria-labelledby="demo-radio-buttons-group-label"
                onChange={handleChange}
                onFocus={onFocus}
                className={"widthMaxContent"}
                id={id}
            >
                {
                    choices?.map(choice => {
                        return (
                            <FormControlLabel
                                checked={values.includes(`${choice.id}`)}
                                key={choice.id}
                                value={choice.id}
                                control={<Checkbox/>}
                                label={choice.text === null || choice.text === "" ? "(empty)" : choice.text}
                                className={"textWrap"}
                                onKeyPress={e => {
                                    if (!values.includes(`${choice.id}`)) {
                                        if (e.key === "Enter") {
                                            const ev = {
                                                target: {
                                                    value: choice.id.toString(),
                                                    checked: !(values.includes(`${choice.id}`))
                                                }
                                            }
                                            //@ts-ignore
                                            handleChange(ev);
                                        }
                                    }
                                }}
                            />
                        )
                    })
                }
                {other === true
                    ? <FormControlLabel
                        value={"Other"}
                        checked={!!values.find(a => a.includes("o:"))}
                        control={<Checkbox/>} label={t("Other")}
                        onKeyPress={e => {
                            if (!values.find(a => a.includes("o:"))) {
                                if (e.key === "Enter") {
                                    const ev = {
                                        target: {
                                            value: "Other",
                                            checked: !(value.includes("o:"))
                                        }
                                    }
                                    //@ts-ignore
                                    handleChange(ev);
                                }
                            }
                        }}
                    />
                    : null
                }
            </FormGroup>
            {
                values.find(a => a.includes("o:"))
                    ? <TextField error={errorText !== ""}
                                 value={values.find(a => a.includes("o:"))?.substring(2)}
                                 onChange={handleOtherChange}
                                 label={t("Other")} variant="outlined"
                                 InputProps={{
                                     endAdornment: <InputAdornment position="end">
                                         <StatusComponent status={status}/>
                                     </InputAdornment>,
                                 }}
                                 onDrop={preventDefaultOnDropFiles}
                    />
                    : null
            }
            {errorText !== "" ? <FormHelperText error>{errorText}</FormHelperText> : null}
        </FormControl>
    )
}

export default withSharedMemo(CheckboxesComponent)